import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';

import LandingPage from './pages/landing/LandingPage';
import {
  editGoalPageRoute,
  goalsPageRoute,
  setGoalPageRoute,
  singleGoalPageRoute,
  singleTaskPageRoute,
  tasksPageRoute,
} from './common/linkRoutes';
import GoalsPage from './pages/goals/GoalsPage';
import GoalPage from './pages/goals/GoalPage';
import TasksPage from './pages/tasks/TasksPage';
import TaskPage from './pages/tasks/TaskPage';
import SetGoalPage from './pages/goals/SetGoalPage';
import { Helmet } from 'react-helmet';
import './firebase/initFirebase';
import EditGoalPage from './pages/goals/EditGoalPage';
import { useEffect } from 'react';
// import ReactGA from "react-ga4";
// import { createBrowserHistory as createHistory } from 'history'


// const measurementId: string = process.env.REACT_APP_MEASUREMENT_ID || ''

// const history = createHistory()
//   ReactGA.initialize(measurementId);
//   history.listen((location, action) => {
//     ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
// });

export default function App() {
  useEffect(() => {
        // redirect user to main url
    const mainURL ='https://goal-organizer.shelomoh.work/'
    if ( process.env.NODE_ENV !=='development' && window.location.href !==mainURL ) {
         window.location.href = mainURL
    }
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Goal Organizing App</title>
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
      </Helmet>

      <Router>
        <Switch>
          <Route path={'/'} exact component={LandingPage} />

          <Route path={goalsPageRoute} exact component={GoalsPage} />
          <Route path={setGoalPageRoute} exact component={SetGoalPage} />
          <Route path={singleGoalPageRoute} exact component={GoalPage} />
          <Route path={editGoalPageRoute} exact component={EditGoalPage} />

          <Route path={tasksPageRoute} exact component={TasksPage} />
          <Route path={singleTaskPageRoute} exact component={TaskPage} />
        </Switch>
      </Router>
    </div>
  );
}
